import {
    ReactNode, useEffect, useRef, useState,
} from 'react';

const ANIMATION_DURATION_MS = 300;

function usePermissionExpand(children?: ReactNode) {
    const [expand, setExpand] = useState(false);
    const [maxHeight, setMaxHeight] = useState<number>(0);
    const [isLoad, setIsLoad] = useState<boolean>(false);
    const ref = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (ref.current) {
            setMaxHeight(ref.current.scrollHeight);
            const timeout = setTimeout(() => {
                setIsLoad(true);
            }, ANIMATION_DURATION_MS);
            return () => clearTimeout(timeout);
        }
        return () => {};
    }, [ref.current, children]);

    const toggleExpand = () => {
        setExpand(!expand);
    };

    return {
        expand, maxHeight, ref, toggleExpand, isLoad,
    };
}

export default usePermissionExpand;
